// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/canvases_for_clicked_shortened_sms_link" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasesForClickedShortenedSmsLink } from "./constants";
import type { EngagementCanvasesForClickedShortenedSmsLinkResult } from "./types";

export const getEngagementCanvasesForClickedShortenedSmsLink = reactQueryFetcherAdapter(
  engagementCanvasesForClickedShortenedSmsLink,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    filterKey?: string
  ): Promise<EngagementCanvasesForClickedShortenedSmsLinkResult> => {
    return fetch(
      "/engagement/canvases_for_clicked_shortened_sms_link",
      "GET",
      { app_group_id: appGroupId, query, limit, filter_key: filterKey },
      { signal }
    );
  }
);
